module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.5134/img/storefront-header-blobs.svg"